import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { Popconfirm, PopconfirmProps, GlobalToken } from 'antd';
import cn from 'classnames';

import IconBack from '@/assets/icon-back.svg?react';

interface NavBackProps {
  url: string;
  popConfirmProps?: PopconfirmProps;
  disabled?: boolean;
}

const NavBack = ({ url, popConfirmProps, disabled, ...rest }: NavBackProps) => {
  const navigate = useNavigate();

  const onClickIconBack = () => {
    navigate(url);
  };

  return (
    <Container {...rest}>
      {popConfirmProps ? (
        <Popconfirm {...popConfirmProps} onConfirm={onClickIconBack}>
          <Link to={url}>
            <IconBack className={cn('icon-back', { disabled })} />
          </Link>
        </Popconfirm>
      ) : (
        <Link to={url}>
          <IconBack className={cn('icon-back', { disabled })} />
        </Link>
      )}
    </Container>
  );
};

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  .icon-back {
    cursor: pointer;

    &:hover {
      path {
        fill: ${({ theme: { token } }) => token.colorText};
      }
    }
  }
`;

export default NavBack;
